import { useQuery } from "react-query";
import { DEV_SERVER } from "../constants/urls";
import axios from "axios";
import { userSignal } from "../signal/userSignal";
import { toast } from "react-toastify";
import { productSignal } from "../signal/productSignal";


export const getProducts = async () => {

    try{
        let resp = await axios.get(`${DEV_SERVER}/product/v2`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
    
        });

        let data = resp.data;

        if (data.status) {
            let temp = {}
            data?.data?.map((product) => {
                temp[product.id] = product
            })
            productSignal.value = temp
            return true
        } else {
            toast.error(data.message);
            return false
        }
    }catch(error) {
        if (error.response?.data?.message) {
            toast.error(error?.response?.data?.message);
            return false
        } else {
            toast.error("Something went wrong");
            return false
        }
    }
}